import { render, staticRenderFns } from "./boarding-pass-link.vue?vue&type=template&id=f970f54c&scoped=true"
import script from "./boarding-pass-link.vue?vue&type=script&lang=js"
export * from "./boarding-pass-link.vue?vue&type=script&lang=js"
import style0 from "./boarding-pass-link.vue?vue&type=style&index=0&id=f970f54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f970f54c",
  null
  
)

export default component.exports